import React from 'react';
import Button from '../ui/Button';
import Placeholder from '../../media/brey_digital.png'
import { toTitleCase, toUppercase, toSentenceCase } from '../../utils/dataUtils';

function ItemDetailsModal({ item, onClose }) {

    // const renderChangeHistory = (updateHistory) => {
    //     return updateHistory.map((update, index) => (
    //         Object.entries(update.changes).map(([field, values], i) => (
    //             <p key={`${index}-${i}`}>
    //                 The <strong>{field}</strong> was updated from <strong>{values.oldValue}</strong> to <strong>{values.newValue}</strong> on <strong>{new Date(update.updatedAt).toLocaleString()}</strong> by <strong>{update.updatedBy}</strong>.
    //             </p>
    //         ))
    //     ));
    // };

    const renderChangeHistory = (updateHistory) => {
        return updateHistory.map((update, index) => {
            const changes = Object.entries(update.changes).map(([field, values]) => (
                `The ${field} was updated from ${values.oldValue} to ${values.newValue}`
            ).join(", "));

            return (
                <p key={index}>
                    {changes} on <strong>{new Date(update.updatedAt).toLocaleString()}</strong> by <strong>{update.updatedBy}</strong>.
                </p>
            );
        });
    };

    const sortedUpdateHistory = [...item.updateHistory].sort((a, b) => 
        new Date(b.updatedAt) - new Date(a.updatedAt)
    );

    const options = {
        year: '2-digit',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };

    return (
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-auto z-[9999]">
    <div className="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] flex flex-col">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-4">
            <h2 className="text-3xl font-bold text-gray-900">{toTitleCase(item.name)}</h2>
            <p className="text-lg text-gray-600 dark:text-gray-400">{item.altname || ""}</p>
        </div>

        {/* Main Content Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-2">
            {/* Left Column: Item Details */}
            <div className="space-y-4">
                <p className="text-gray-700">
                    <strong>Quantity:</strong> {item.quantity} {item.unitType}
                </p>
                {/* <div className="flex justify-between items-center">
                    <p className="text-gray-700">
                        <strong>Selling Price:</strong> ₹{item.price}
                    </p>
                    <p className="text-gray-700">
                        <strong>Cost Price:</strong> ₹{item.costPrice}
                    </p>
                </div> */}
                <p className="text-gray-700">
                    <strong>Group:</strong> {item.group}
                </p>
                <p className="text-red-500">
                    <strong className='text-gray-700'>Low Stock Threshold:</strong> {item.lowStockThreshold}
                </p>
                {/* <p className="text-gray-700">
                    <strong>Last Modified:</strong> {new Date(item.updatedAt).toLocaleString('en-IN', options)}
                </p> */}
                <h3 className="text-xl font-semibold text-gray-900">Description</h3>
                <p className="text-gray-600 dark:text-gray-400 mb-3">
                    {item.description || 'No description available.'}
                </p>
            </div>

            {/* Right Column: Image */}
            <div className="w-full h-64 rounded-lg overflow-hidden">
                <img
                    src={item.image || `https://dummyimage.com/640x600/ff4520/fff&text=${toTitleCase(item.name)}`}
                    alt={item.name}
                    className="w-full h-full object-cover"
                />
            </div>
        </div>

        {/* Description Section */}
        {/* <div className="mb-4">
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Description</h3>
            <p className="text-gray-600 dark:text-gray-400">
                {item.description || 'No description available.'}
            </p>
        </div> */}

        {/* Change History Section */}
        {sortedUpdateHistory.length > 0 && (
        <>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">Change History</h3>
        <div className="flex-1 overflow-y-auto">
            <div className="space-y-2 pr-2">
                {sortedUpdateHistory.map((update, index) => (
                    <div key={index} className="bg-gray-700 p-4 rounded-lg shadow-sm">
                        <p className="text-gray-100">
                            <strong>Updated on:</strong> {new Date(update.updatedAt).toLocaleString('en-IN', options)} by{" "}
                            <strong>{update.updatedBy}</strong>
                        </p>
                        {update.changes && Object.keys(update.changes).length > 0 && (
                        <ul className="mt-2 space-y-2">
                            {Object.entries(update.changes).map(([field, values]) => (
                            <li key={field} className="text-gray-200">
                                The <strong>{field}</strong> was updated from{" "}
                                <strong>{values.oldValue}</strong> to{" "}
                                <strong>{values.newValue}</strong>.
                            </li>
                            ))}
                        </ul>
                        )}
                    </div>
                ))}
            </div>
        </div>
        </>
        )}


        {/* Close Button */}
        <div className="mt-6 flex items-center justify-between">
            <div className="text-xs text-gray-500">
            Created by: {item.createdBy || "NA"} at {new Date(item.createdAt).toLocaleString('en-IN', options)} <br />
            Last Modified at: {new Date(item.updatedAt).toLocaleString('en-IN', options)}
            </div>
            <button
                onClick={onClose}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
                Close
            </button>
        </div>
    </div>
</div>
    );
}

export default ItemDetailsModal;